import { proxy } from "valtio"

// if the current floor is 10 then shows Main

// if the current floor is 21 then shows Block A
// if the current floor is 22 then shows Block B

// if the current floor is 31 then shows "Choose Apartment in Block A"
// if the current floor is 32 then shows "Choose Apartment in Block B"

interface StoreTypes {
  selectedObject: 'А' | 'Б'
  selectedFloor: number
  selectedApartment: number
  currentPage: 10 | 21
}

export const AppStore = proxy<StoreTypes>({
  selectedObject: 'А',
  selectedFloor: 3,
  selectedApartment: 1,
  currentPage: 10
})
